import { useEffect, useState } from "react";
import axios from "axios";
import { BarChart3 } from "lucide-react";
import { API, STATUS_META, STATUS_ORDER, ROLE_LABELS, ROLE_BADGE } from "./constants";

export const PerformanceView = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/performance`, { withCredentials: true })
      .then((res) => setRows(res.data))
      .catch(() => setRows([]));
  }, []);

  return (
    <div className="mt-6" data-testid="performance-view">
      <div className="rounded-xl border border-border bg-white p-6 shadow-soft">
        <div className="flex items-center gap-2">
          <BarChart3 size={16} className="text-amberdark" />
          <h2 className="font-display text-lg font-extrabold tracking-tight text-navy">Team Performance</h2>
        </div>
        <p className="mt-1 text-xs text-gray-500">How many leads each person holds, and how far each has moved.</p>

        {rows === null ? (
          <p className="py-8 text-xs font-bold uppercase tracking-[0.2em] text-gray-500" data-testid="performance-loading">Loading...</p>
        ) : rows.length === 0 ? (
          <p className="py-8 text-xs font-bold uppercase tracking-[0.2em] text-gray-500" data-testid="performance-empty">No team members yet.</p>
        ) : (
          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3" data-testid="performance-grid">
            {rows.map((r, i) => (
              <div key={r.id} className="rounded-xl border border-border bg-white p-6" data-testid={`perf-card-${i}`}>
                <div className="flex items-center justify-between gap-2">
                  <p className="font-display text-lg font-bold tracking-tight text-navy">{r.name}</p>
                  <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${ROLE_BADGE[r.role] || ROLE_BADGE.staff}`}>
                    {ROLE_LABELS[r.role] || "Staff"}
                  </span>
                </div>
                <p className="mt-4 font-display text-4xl font-extrabold tracking-tight text-navy" data-testid={`perf-assigned-${i}`}>
                  {r.assigned}
                  <span className="ml-2 text-xs font-bold uppercase tracking-wider text-gray-400">assigned</span>
                </p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {STATUS_ORDER.map((s) => (
                    <span key={s} className={`rounded-md border px-2 py-1 text-[10px] font-bold ${STATUS_META[s].cls}`}>
                      {STATUS_META[s].label}: {r.by_status?.[s] || 0}
                    </span>
                  ))}
                </div>
                {r.assigned > 0 && (
                  <p className="mt-4 text-xs font-semibold text-gray-500">
                    Win rate: <span className="font-bold text-green-700">{Math.round(((r.by_status?.won || 0) / r.assigned) * 100)}%</span>
                  </p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
